import { useQuery } from '@gogame/query';

import { useTemplates } from '../TemplatesProvider';
import { loadStatusTemplates } from '../source/status-templates';
import { templatesQuery } from './queryKeyFactory';

export const useStatusTemplates = ({ name } = {}) => {
  const { serverPageId } = useTemplates();

  const { data } = useQuery(
    templatesQuery.query(serverPageId).all(),
    (_, { signal }) =>
      loadStatusTemplates({ pageId: serverPageId }, { signal }),
    {
      cacheTime: 5 * 60 * 1000,
    }
  );

  return (name ? data?.[name] : data)?.isUpdated;
};
